import { jsx as _jsx } from "react/jsx-runtime";
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import MobileDisputeLineItem from './mobile';
import DesktopDisputeLineItem from './desktop';
var DisputesLineItem = function (_a) {
    var amount = _a.amount, merchantName = _a.merchantName, postedDate = _a.postedDate, transactionStatus = _a.transactionStatus;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    return isLessThanTablet ? (_jsx(MobileDisputeLineItem, { amount: amount, postedDate: postedDate, merchantName: merchantName, transactionStatus: transactionStatus })) : (_jsx(DesktopDisputeLineItem, { amount: amount, postedDate: postedDate, merchantName: merchantName, transactionStatus: transactionStatus }));
};
export default DisputesLineItem;
//# sourceMappingURL=index.js.map